export default __webpack_public_path__ + "static/media/Onest-Medium.085cce48.woff2";